import { IDocument } from '@pf/shared-common';
import { AbstractEntityStore } from '../abstractions/AbstractEntityStore';

export class DocumentsStore extends AbstractEntityStore<IDocument> {
    constructor(entityName: string) {
        super(`${entityName}-documents`);
    }
}
